import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";
import DebateReportPanel from "@/components/DebateReportPanel";
import { toast } from "sonner";

export default function DebateReport() {
  const { debateId } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/debate/${debateId}/report`)
      .then(({ data }) => setReport(data))
      .catch((e) => setError(e?.response?.data?.detail || "Could not load debate report."));
  }, [debateId]);

  const downloadPdf = async () => {
    try {
      const { data } = await api.get(`/debate/${debateId}/report.pdf`, { responseType: "blob" });
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `thoughtsmith-report-${debateId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not export report PDF.");
    }
  };

  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12 sm:py-16">
        <div className="flex flex-wrap gap-4 mb-10">
          <Link to="/progress" className="text-xs uppercase tracking-[0.25em] text-forge-100/45 hover:text-ember-400">Back to Progress</Link>
          <Link to={`/debate/${debateId}`} className="text-xs uppercase tracking-[0.25em] text-forge-100/45 hover:text-ember-400">Open Debate</Link>
          {report && (
            <button onClick={downloadPdf} className="text-xs uppercase tracking-[0.25em] text-ember-400 hover:text-ember-300">
              Export PDF
            </button>
          )}
        </div>
        {error ? (
          <div className="border border-red-500/30 bg-red-500/10 p-5 text-sm text-red-200">{error}</div>
        ) : !report ? (
          <div className="text-sm tracking-[0.3em] uppercase text-ember-500 animate-pulse">Loading report...</div>
        ) : (
          <DebateReportPanel report={report} />
        )}
      </main>
    </div>
  );
}
